import { Injectable } from '@angular/core';
// eslint-disable-next-line max-len
import { Vehicle } from '@quorum/models/xs-resource';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import * as fromVehicles from './vehicles.actions';
import { VehiclesState } from './vehicles.interfaces';
import { map } from 'rxjs/operators';
@Injectable()
export class VehiclesEffects {
  
  getServiceGroupsFromServer = createEffect(() => this.dataPersistence.fetch(fromVehicles.GET_VEHICLES_FROM_SERVER, {
    run: (action: fromVehicles.GetVehiclesFromServer, state: VehiclesState) => {
      return this.apiService
        .get<Vehicle[]>(`v/1/vehicles/vehicles`, {
          params: action.payload
        })
        .pipe(
          map(
            vehicles =>
              new fromVehicles.GetVehiclesFromServerSuccess({
                vehicles: vehicles
              })
          )
        );
    },
    onError: (action: fromVehicles.GetVehiclesFromServer, error) => {
      console.error('Error', error);
    }
  }));

  constructor(
    private actions: Actions,
    private dataPersistence: DataPersistence<VehiclesState>,
    private apiService: ApiService
  ) {}
}
